import { HttpErrorResponse } from '@angular/common/http';
import { ViewChild } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser } from '../../../../models/clpuser.model';
import { eUserRole } from '../../../../models/enum.model';
import { IntDropDownItem, SimpleResponse } from '../../../../models/genericResponse.model';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';
import { CLPSMTP, CLPSMTPListResponse, CLPSMTPResponse } from '../../../../models/smtp.model';
import { AccountSetupService } from '../../../../services/accountSetup.service';
import { GlobalService } from '../../../../services/global.service';
import { NotificationService } from '../../../../services/notification.service';
import { LocalService } from '../../../../services/shared/local.service';
import { UtilityService } from '../../../../services/shared/utility.service';

@Component({
    selector: 'smtp-setting',
    templateUrl: './smtpsetting.component.html',
    styleUrls: ['./smtpsetting.component.css']
})

export class SmtpsettingComponent implements OnInit {
    @Input() user: CLPUser;
    @Input() companyIdSmtp: number;
    @Input() roleFeaturePermissions: RoleFeaturePermissions;
    encryptedUser: string;
    showSpinner: boolean = false;
    smtpUserList: IntDropDownItem[] = [];
    smtpForm: FormGroup;
    smtpFormData: CLPSMTP;
    selectedUser: number = 0;
    smtpEditMode: number = 0;
    cancelEditSmtp: boolean = false;
    smtpSettingresponse: CLPSMTPListResponse;
    sendTestSuccess: boolean = false;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    clpSmtpListSource: MatTableDataSource<any>;
    clpSmtpListDisplayColumns: string[] = [];
    warningStr: string = '';

    clpsmtpList: CLPSMTP[];
    columns = [
        { field: 'name', title: 'Name', width: '91' },
        { field: 'email', title: 'Email', width: '130' },
        { field: 'enableCLPSMTP', title: 'SMTP Active', width: '60' },
        { field: 'cLPSMTPID', title: 'CLPSMTPID', width: '50' },
        { field: 'cLPCompanyID', title: 'CLPCompanyID', width: '50' },
        { field: 'cLPUserID', title: 'CLPUserID', width: '75' },
        { field: 'sMTPServer', title: 'SMTPServer', width: '137' },
        { field: 'sMTPPort', title: 'SMTPPort', width: '50' },
        { field: 'sMTPAuthenticate', title: 'SMTPAuthenticate', width: '90' },
        { field: 'username', title: 'UserName', width: '100' },
        { field: 'passwordValue', title: 'Password', width: '100' },
        { field: 'useSSL', title: 'UseSSL', width: '30' },
    ];
    reorderColumnName: string = 'name,email,enableCLPSMTP,cLPSMTPID,cLPCompanyID,cLPUserID,sMTPServer,sMTPPort,sMTPAuthenticate,username,passwordValue,useSSL';
    columnWidth: string = 'name:91,email:130,enableCLPSMTP:60,cLPSMTPID:50,cLPCompanyID:50,cLPUserID:75,sMTPServer:137,sMTPPort:50,sMTPAuthenticate:90,username:150,passwordValue:100,useSSL:30';
    arrColumnWidth: any[] = ['name:91,email:130,enableCLPSMTP:60,cLPSMTPID:50,cLPCompanyID:50,cLPUserID:75,sMTPServer:137,sMTPPort:50,sMTPAuthenticate:90,username:150,passwordValue:100,useSSL:30'];

    mobileColumnNames: string[];
    constructor(public _router: Router, private _accountSetupService: AccountSetupService,
        private _globalService: GlobalService,
        private _notifyService: NotificationService,
        private fb: FormBuilder,
        public _localService: LocalService,
        private _utilityService: UtilityService) {

    }


    ngOnInit() {

        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                if (this.user) {
                    if (this.user?.userRole <= eUserRole.Administrator) {
                        if (this.roleFeaturePermissions?.view == false)
                            this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                        else
                            this.loadInit();
                    }
                    else
                        this.loadInit();
                }
                else
                    this._router.navigate(['/login']);
            }
            else
                this._router.navigate(['/login']);
        });
    }

    loadInit() {
        this.smtpForm = this.prepareSmtpForm();
        this.getSmtpSettings();
    }

    async getSmtpSettings() {
        this.showSpinner = true;
        this.companyIdSmtp = (!!this.companyIdSmtp && this.companyIdSmtp > 0) ? this.companyIdSmtp : this.user.cLPCompanyID;
        await this._accountSetupService.getClpSMTPList(this.encryptedUser, this.companyIdSmtp)
            .then(async (result: CLPSMTPListResponse) => {
                if (result) {
                    this.smtpSettingresponse = UtilityService.clone(result);
                    this.smtpUserList = this.smtpSettingresponse?.userList;
                    this.clpsmtpList = this.smtpSettingresponse?.clpsmtpList;
                    this.setGrid(this.clpsmtpList);
                    //this.smtpForm.reset();
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("smtp-setting.getSmtpSettings", err.message, null, 'companyIdSmtp ' + this.companyIdSmtp + "," + "cLPUserID " + this.user.cLPUserID);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadSmtpSettings() {
        if (this.smtpForm.controls.selectedUserId.value > 0) {
        this.selectedUser = this.smtpForm.controls.selectedUserId.value;
        this.showSpinner = true;
        this.companyIdSmtp = (!!this.companyIdSmtp && this.companyIdSmtp > 0) ? this.companyIdSmtp : this.user.cLPCompanyID;
            await this._accountSetupService.loadClpSMTPByClpuser(this.encryptedUser, this.selectedUser, this.companyIdSmtp)
            .then(async (result: CLPSMTPResponse) => {
                if (result) {
                    this.smtpFormData = UtilityService.clone(result?.clpsmtpData);
                    if (this.smtpFormData.cLPSMTPID > 0)
                        this.patchSmtpFormValue();
                    else
                        this.resetSmtpFormExceptUser();
                    this.smtpEditMode = 1;
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("smtp-setting.loadSmtpSettings", err.message, null, 'clpUserId ' + this.smtpForm.controls.selectedUserId.value + "," + "companyIdSmtp " + this.companyIdSmtp);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
        } 
    }

    smtpUserChange(selectUser: number) {
        if (!isNullOrUndefined(selectUser) && selectUser > 0) {
            this.selectedUser = selectUser;
            this.smtpEditMode = 1;
        }
    }

    cancelSmtp() {
        this.cancelEditSmtp = true;
        this.warningStr = '';
        //this.selectedUser = 0;
        this.sendTestSuccess = false;
        this.smtpEditMode = 0;
        this.smtpForm.controls.selectedUserId.setValue(-1);
    }

    prepareSmtpForm() {
        return this.fb.group({
            selectedUserId: new FormControl(-1),
            username: new FormControl('', [Validators.required]),
            password: new FormControl('', [Validators.required]),
            sMTPPort: new FormControl(25, [Validators.required]),
            sMTPAuthenticate: new FormControl(1),
            useSSL: new FormControl(false),
            enableCLPSMTP: new FormControl(false),
            sMTPServer: new FormControl(''),
            cLPUserID: new FormControl(0),
            testTo: new FormControl(this.user?.email)
        });
    }
    resetSmtpFormExceptUser() {
        this.smtpForm.reset({
            selectedUserId: this.selectedUser, 
            username: '',
            password: '',
            sMTPPort: 25,
            sMTPAuthenticate: 1,
            useSSL: false,
            enableCLPSMTP: false,
            sMTPServer: '',
            cLPUserID: 0,
            testTo: this.user?.email
        });

        this.smtpEditMode = 0;
    }

    get smtpFormFrm() {
        return this.smtpForm.controls;
    }

    getUserName(userId) {
        if (!isNullOrUndefined(this.smtpUserList)) {
            const userData = this.smtpUserList.filter(item => item.id == userId)[0];
            return userData ? userData.text : '';
        }
    }

    patchSmtpFormValue() {
        const smtpFormDt = this.smtpFormData;
        for (let key in smtpFormDt) {
            let value = smtpFormDt[key];
            if (this.smtpForm.get(key))
                this.smtpForm.get(key).setValue(value);
        }
    }


    copyValueFromSmtpFormToData() {
        this.smtpFormData.cLPUserID = this.selectedUser;
        this.smtpFormData.cLPCompanyID = (!!this.companyIdSmtp && this.companyIdSmtp > 0) ? this.companyIdSmtp : this.user.cLPCompanyID;
        this.smtpFormData.username = this.smtpForm.controls.username.value;
        this.smtpFormData.password = this.smtpForm.controls.password.value;
        this.smtpFormData.sMTPPort = this.smtpForm.controls.sMTPPort.value;
        this.smtpFormData.sMTPAuthenticate = this.smtpForm.controls.sMTPAuthenticate.value;
        this.smtpFormData.useSSL = this.smtpForm.controls.useSSL.value;
        this.smtpFormData.enableCLPSMTP = this.smtpForm.controls.enableCLPSMTP.value;
        this.smtpFormData.sMTPServer = this.smtpForm.controls.sMTPServer.value;
    }

    smtpFormSubmit() {
        this._localService.validateAllFormFields(this.smtpForm);
        if (this.smtpForm.valid) {
            this.smtpForm.markAsPristine();
            this.updateSmtpForm();
        }
        else
            this._notifyService.showError("Invalid Smtp Fields", "", 3000);

    }
    updateSmtpForm() {
        this.copyValueFromSmtpFormToData();
        this.showSpinner = true;
        this._accountSetupService.updateClpSMTP(this.encryptedUser, this.smtpFormData, this.user?.cLPUserID, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (result && result.messageBool) {
                    //this.selectedUser = null;
                    this._notifyService.showSuccess('', 'Settings saved. Select a user to edit SMTP settings.', 3000);
                    this.sendTestSuccess = false;
                    await this.getSmtpSettings();
                    this.smtpForm = this.prepareSmtpForm();
                    this.cancelEditSmtp = true;
                    this.smtpEditMode = 0;
                } else if (result && result.messageString === 'User does not exist.')
                    this._notifyService.showError('', result.messageString);
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("smtp-setting.updateSmtpForm", err.message, this.smtpFormData, 'cLPUserID ' + this.user?.cLPUserID + "," + "cLPUserID " + this.user.cLPUserID);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    sendTestEmail() {
        this.copyValueFromSmtpFormToData();
        this.smtpFormData.email = this.smtpForm.controls.testTo.value;
        this.showSpinner = true;
        this._accountSetupService.testClpSMTP_AdminSMTPSettings(this.encryptedUser, this.smtpFormData, this.user?.cLPUserID, this.user?.cLPCompanyID)
            .then((result: SimpleResponse) => {
                if (result) {
                    const response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        this.warningStr = '';
                        this.sendTestSuccess = true;
                        this._notifyService.showSuccess("Email was sent successfully.  Click Confirm to save changes.", "", 3000);
                    }
                    else {
                        this.warningStr = response?.messageString;
                        this.smtpEditMode = 1;
                        this.sendTestSuccess = false;
                        this._notifyService.showError("Email failed.  Fix and try again.", "", 3000);
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("smtp-email-setting.sendTestEmail", err.message, this.smtpFormData);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    onNext() {
        this.smtpEditMode = 2;
        this.warningStr = '';
    }
    setGrid(list: CLPSMTP[]) {
        const normalized = list.map(x => ({
            cLPSMTPID: x.cLPSMTPID,
            cLPCompanyID: x.cLPCompanyID,
            cLPUserID: x.cLPUserID,
            sMTPServer: x.sMTPServer,
            sMTPPort: x.sMTPPort,
            sMTPAuthenticate: x.sMTPAuthenticate,
            username: x.username,
            name: x.name,
            passwordValue: x.password,
            email: x.email,
            enableCLPSMTP: x.enableCLPSMTP ?? false,
            useSSL: x.useSSL === true  
        }));

        this.clpSmtpListDisplayColumns = this.columns.map(c => c.field);
        this.clpSmtpListSource = new MatTableDataSource(normalized);       
        setTimeout(() => {
            this.clpSmtpListSource.paginator = this.paginator;
            this.clpSmtpListSource.sort = this.sort;
        });
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();

    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    onDeleteSMTPSetting() {
        this.showSpinner = true;
        this._accountSetupService.clearSMTPSetting(this.encryptedUser, this.selectedUser, this.user?.cLPCompanyID, this.smtpFormData.cLPSMTPID)
            .then(async (result: SimpleResponse) => {
                if (result && result.messageBool) {
                    this._notifyService.showSuccess('Settings have been cleared. Select a user to edit SMTP settings.','',3000)
                    this.smtpForm = this.prepareSmtpForm();
                    this.cancelSmtp();
                    await this.getSmtpSettings();
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("smtp-setting.clearSetting", err.message, null, 'cLPUserID ' + this.user.cLPUserID + "," + "cLPSMTPID " + this.smtpFormData.cLPSMTPID);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }
}
